import { SliderNews } from '@/component/Slider';
import { SearchNews, LATEST_NEWS_SLUG } from '@/query';
import { usePostsSlider } from './usePostsSlider';

export const LatestNews = (props) => {
  const { called, posts, handleNext, loading, metadata } = usePostsSlider({
    placement: LATEST_NEWS_SLUG,
    query: SearchNews,
  });

  return called && posts?.length ? (
    <SliderNews
      items={posts}
      onLoadMore={handleNext}
      loading={loading}
      hasNextPage={metadata.hasNextPage}
      title={metadata.title}
      subtitleKey="slider.news.description"
      readMore
      dataTestId="latest-news"
      {...props}
    />
  ) : null;
};
